import { Flex } from '@chakra-ui/react'
import { useState } from 'react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { InputCmp } from '../../../../../components/InputCmp'

interface props {
  isOpen: boolean
  onRequestClose: () => void
  onConfirm: (dataFim: string) => void
  dataMinima?: string
}

export const ModalReabrir: React.FC<props> = ({ isOpen, onRequestClose, onConfirm, dataMinima }) => {
  Modal.setAppElement('#root')
  const [DataFim, setDataFim] = useState('')
  return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            overlayClassName='react-modal-overlay'
            className='react-modal-content-poupUp'
        >
            <Flex pos={'absolute'} top={'10px'} right={'10px'}>
                <MdClose size={18} color={'var(--Red)'} cursor={'pointer'} onClick={onRequestClose} />
            </Flex>

            <Flex flexDir={'column'} gap={'.5rem'}>
                <h3>Defina a nova data de término:</h3>
                <InputCmp
                    width={'15rem'}
                    type={'date'}
                    min={dataMinima ? new Date(`${dataMinima.split('/')[2]}-${dataMinima.split('/')[1]}-${dataMinima.split('/')[0]}T00:00:00Z`).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
                    max={'2099-12-31T23:59'}
                    OnChange={setDataFim}
                />
                <Flex justifyContent={'center'} pl={'.2rem'}>
                    <ButtonCmp isDisabled={!DataFim} VarColor='Green2' onClick={() => { onConfirm(DataFim) }}>Confirmar</ButtonCmp>
                </Flex>
            </Flex>

        </Modal>
  )
}
